import { jsx as _jsx } from "react/jsx-runtime";
export const ColorPicker = ()=>/*#__PURE__*/ _jsx("div", {
        children: "Color Picker dummy"
    });

//# sourceMappingURL=ColorPicker.js.map